<!-- =========================================================================================
  File Name: DashboardAnalytics.vue
  Description: Dashboard Analytics
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="dashboard-analytics">
    <!-- {{ store._actions["user/getCurrentUser"][0] }} -->
    <!-- {{ dash }} -->
    <div class="flex flex-wrap items-center flex-start">
    <!-- <vs-button
      class="ml-2 mr-2 mb-1 ml-auto"
      color="primary"
      icon-pack="feather"
      icon="icon-printer"
      @click="baixarRelatorio"
      >Gerar Relatório de Auditoria</vs-button
    > -->
    <vs-button
      v-if="visible"
      color="success"
      icon-pack="feather"
      :href="relatorio"
      target="_blank"
      icon="icon-download"
      @click="relatorio = ''"
      >Download</vs-button
    >
    </div>
    <br>
    <div class="vx-row" v-if="dataNotLoading">
      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4">
        <statistics-card-line
          hideChart
          class="mb-base"
          icon="UserIcon"
          icon-right
          :statistic="dash.activeEmployee[0].total"
          statisticTitle="Funcionarios activos"
          color="success"
        />
      </div>
      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4">
        <statistics-card-line
          hideChart
          class="mb-base"
          icon="UserIcon"
          icon-right
          :statistic="dash.inactiveEmployee[0].total"
          statisticTitle="Funcionarios desactivos"
          color="warning"
        />
      </div>
      <div class="vx-col w-full sm:w-1/2 md:w-1/2 mb-base">
        <vx-card title="Feriados do corrente mês">
          <ul class="vx-timeline">
            <li v-for="holiday in dash.holidays" :key="id">
              <div class="timeline-icon bg-success">
                <feather-icon
                  icon="CalendarIcon"
                  svgClasses="text-white stroke-current w-5 h-5"
                />
              </div>

              <small class="text-bold">
                <strong> Dia:</strong> {{ holiday.holiday }}</small
              >
              <div class="timeline-info">
                <p class="font-semibold">{{ holiday.description }}</p>
              </div>
            </li>
          </ul>

          <div v-if="dash.holidays == ''">SEM FERIADOS</div>
        </vx-card>
      </div>
      <div class="vx-col w-full sm:w-1/2 md:w-1/2 mb-base">
        <vx-card title="Contratos prestes a expirar/expirados">
          <ul class="vx-timeline">
            <li v-for="expire in dash.contracts_that_will_expire" :key="id">
              <div v-if="expire.days >= 1" class="timeline-icon bg-warning">
                <feather-icon
                  icon="FileTextIcon"
                  svgClasses="text-white stroke-current w-5 h-5"
                />
              </div>
              <div v-if="expire.days <= 0" class="timeline-icon bg-danger">
                <feather-icon
                  icon="FileTextIcon"
                  svgClasses="text-white stroke-current w-5 h-5"
                />
              </div>
              <div class="timeline-info">
                <p class="font-semibold">
                  {{ expire.name }} {{ expire.surname }}
                </p>
              </div>
              <small class="text-bold" v-if="expire.days >= 1">
                <strong> Expira em:</strong> {{ expire.expiry_date }}</small
              >
              <small class="text-bold" v-if="expire.days <= 0">
                <strong> Expirou em:</strong> {{ expire.expiry_date }}</small
              >
              <br />
              <small class="text-bold"
                ><strong>Nacionalidade:</strong> {{ expire.nationality }}</small
              >
              <br />
              <small class="text-bold">
                <a target="_blank" :href="expire.attachment">Baixar contrato</a>
              </small>
            </li>
          </ul>

          <div v-if="dash.contracts_that_will_expire == ''">SEM CONTRATOS</div>
        </vx-card>
      </div>
      <div class="vx-col w-full sm:w-1/2 md:w-1/2 mb-base">
        <vx-card title="Aniversáriantes do corrente mês">
          <ul class="vx-timeline">
            <li v-for="aniversario in dash.birthdays" :key="id">
              <div class="timeline-icon bg-primary">
                <feather-icon
                  icon="GiftIcon"
                  svgClasses="text-white stroke-current w-5 h-5"
                />
              </div>
              <div class="timeline-info">
                <p class="font-semibold">
                  {{ aniversario.name }} {{ aniversario.surname }}
                </p>
                <!-- <span class="activity-desc">xxxx</span> -->
              </div>
              <small class="text-bold">Dia: {{ aniversario.birth_day }}</small>
            </li>
          </ul>

          <div v-if="dash.birthdays == ''">SEM ANIVERSÁRIANTES</div>
        </vx-card>
      </div>
    </div>

    <div
      v-else
      style="height: 50px"
      id="div-with-loading"
      class="vs-con-loading__container"
    ></div>
  </div>
</template>

<script>
import http from "../../../../../http-common";
import StatisticsCardLine from "@/components/statistics-cards/StatisticsCardLine.vue";
import VxTimeline from "@/components/timeline/VxTimeline.vue";
import { PermissionsMixin } from "../../../../mixins/permissions";
export default {
  mixins: [PermissionsMixin],
  components: {
    StatisticsCardLine,
    VxTimeline,
  },
  data() {
    return {
      dash: [],
      search: "",
      dataNotLoading: false,
      relatorio: 'https://drive.google.com/file/d/1VU7zna9eimmfyxZZfiIb7NEbL_S7QyVD/view?usp=sharing',
      visible: false,
    };
  },

  mounted() {
    this.getDash();
  },

  computed: {
    filtered() {
      return this.companies.filter((e) =>
        e.name.toLowerCase().includes(this.search.toLowerCase())
      );
    },
  },

  methods: {
    baixarRelatorio() {
      
      // Extrair o ID do arquivo do link do Google Drive
      const fileId = this.relatorio.match(/\/d\/([^\/]+)/)[1];
      
      // Construir o link de download direto do arquivo
      const downloadLink = `https://drive.google.com/uc?export=download&id=${fileId}`;

      // Criar um elemento <a> para iniciar o download
      const link = document.createElement('a');
      link.href = downloadLink;
      link.target = '_blank'; // Abre em uma nova aba
      // link.click(); // Inicia o download
      this.visible = true;
    },
    getReport() {
      // alert(2);
      // this.$vs.loading();
      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
      };

      http
        .get(
          `performances/department_evaluation_pdfID/${this.$route.params.departmentId}`,
          config
        )
        .then((result) => {
          this.relatorio = result.data.pdf_url;
          this.$vs.loading.close();
        })
        .catch((error) => {
          error;
          // this.$vs.loading();
          if (error.response.status == 401) {
            this.$router.push("/").catch(() => {});
          }
        });
    },
    getDash() {
      this.$vs.loading({
        container: "#div-with-loading",
        scale: 1.0,
        type: "sound",
      });
      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
      };

      http
        .get("/companies/dashboard", config)
        .then((result) => {
          this.dataNotLoading = true;
          this.$vs.loading.close("#div-with-loading > .con-vs-loading");
          this.dash = result.data;
        })
        .catch((error) => {
          error;

          if (error.response.status == 401) {
            this.$router.push("/").catch(() => {});
          }
        });
    },
  },
};
</script>

<style lang="scss">
/*! rtl:begin:ignore */
#dashboard-analytics {
  .greet-user {
    position: relative;

    .decore-left {
      position: absolute;
      left: 0;
      top: 0;
    }

    .decore-right {
      position: absolute;
      right: 0;
      top: 0;
    }
  }

  @media (max-width: 576px) {
    .decore-left,
    .decore-right {
      width: 140px;
    }
  }
}

/*! rtl:end:ignore */
</style>
